import * as React from 'react';
import { observer } from 'mobx-react';
import ParticipantsStore from '../../../ParticipantsStore';
import GroupsStore from '../../../GroupsStore';
import { nothing, Maybe, just } from 'maybeasy';
import clsx from 'clsx';
import { TPlainTextKey, TranslationsContext } from '../../../Translations';
import { valueFor } from '../../../ListFilter';
import SearchIcon from '../../Cutesies/SearchIcon';

interface Props {
  store: ParticipantsStore | GroupsStore;
  label: TPlainTextKey;
  className?: string;
}
interface State {
  debouncer: Maybe<ReturnType<typeof setTimeout>>;
}

class Search extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      debouncer: nothing(),
    };
  }

  handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.state.debouncer.do((debouncer) => clearTimeout(debouncer));

    this.props.store.updatingQuery({ key: 'query', value: event.target.value });
    this.setState({ debouncer: just(setTimeout(() => this.triggerLoading(), 1000)) });
  };

  triggerLoading = () => {
    this.setState({ debouncer: nothing() });
    this.props.store.loading(1);
  };

  render() {
    const { store, label } = this.props;
    return (
      <div className={clsx('relative mt-6 mr-4 w-1/2', this.props.className)}>
        <span className="absolute inset-y-0 left-0 flex items-center pl-4">
          <SearchIcon className="w-6 h-6" />
        </span>
        <TranslationsContext.Consumer>
          {(ts) => (
            <input
              autoFocus
              placeholder={label}
              value={valueFor('query', store.searchParameters)}
              onChange={this.handleSearchChange}
              className={clsx(
                'mt-1 block w-full rounded-md border-1 border-solid',
                'border-gray-300 bg-white pl-10 py-2 text-sm font-medium',
              )}
            />
          )}
        </TranslationsContext.Consumer>
      </div>
    );
  }
}

export default observer(Search);
